import * as _ from 'lodash';

interface Item {
  categorySpend: {
    last12monthSpend: number;
    spendWithSeller: number;
  };
  savings: number;
}

// TODO: Make this a more generic filter zeros by property or array or properties?
export default function FilterZeroSpendAndZeroSavingsFilter() {
  return function (items: Item[]) {
    return _.filter(items, function (item) {
      if (
        item.categorySpend.last12monthSpend === 0 &&
        item.categorySpend.spendWithSeller === 0 &&
        item.savings === 0
      ) {
        return false;
      } else {
        return true;
      }
    });
  };
}
